import base from './seo-pages.json'
import stories from './news-articles.json'
import { withNewsArchivePages } from './news-pagination'

export default withNewsArchivePages(base, stories.length)
